import { render, staticRenderFns } from "./AdminSummary.vue?vue&type=template&id=23a206cd&"
import script from "./AdminSummary.vue?vue&type=script&lang=js&"
export * from "./AdminSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdminSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports